export const TERMS_CONTENT = `
Questguru — Terms & Conditions (Draft)
Questguru provides previous years' question papers, practice modules, and GenAI-assisted paper generation tools to help learners prepare for exams. The Service is intended for personal, non-commercial educational use.

Key Points
- By registering or using the Service you accept these Terms.
- You must be of minimum age or have parent/guardian consent.
- AI outputs are for practice and may be inaccurate.

1. Accounts and Eligibility
- Provide true and accurate information. You are responsible for activity under your account.
- If you are a minor, use requires parental/guardian consent.

2. User Content
- "User Content" includes any content you upload or submit (prompts, files, answers).
- You warrant you have the rights to submit User Content and that it does not infringe third-party rights.
- You grant Questguru a non-exclusive, worldwide, royalty-free license to use User Content to operate and improve the Service, including anonymized research and model improvement.

3. AI-Generated Content
- AI outputs are provided for practice only; do not rely on them for exam answers or professional advice.
- Ownership: you retain ownership of your prompts. Questguru is granted a license to use anonymized prompts and outputs to improve the Service. Contact support for alternative arrangements.

- Safety & Guardrails: We implement content-safety measures and guardrails to minimize the generation of sexually explicit, pornographic, nudity, violent, hateful, abusive, or otherwise harmful content. Despite these measures, AI systems can sometimes produce unexpected or inappropriate outputs.
- Reporting: If you encounter any AI-generated content that is sexual, nudity, abusive, hateful, or otherwise violates these Terms, please report it immediately to info@arithmeticinfotech.com with the prompt, a screenshot (if available), and the approximate time. We will investigate promptly and take remediation steps (for example, blocking the prompt pattern and improving filters).
- Disclaimer on AI outputs: Questguru does not endorse or publish such content; however, to the maximum extent permitted by law, Questguru is not liable for unexpected, offensive, or inappropriate AI-generated outputs. Users should not rely on AI outputs for professional, legal, medical, or examination-critical decisions and must report problematic outputs when encountered.

4. Intellectual Property
- Questguru and its licensors retain all rights in the platform and curated content. You may not redistribute platform content without permission.

5. Acceptable Use
- Do not use the Service for cheating, academic dishonesty, or illegal purposes. Abuse may result in suspension or termination.

6. Copyright Infringement
- For copyright complaints, contact: info@arithmeticinfotech.com. We will follow the applicable law for takedown and counter-notice procedures.

7. Payments and Refunds
- Paid features have clear pricing and billing terms. Refunds are handled per the Refund Policy.

8. Privacy and Data
- See the Privacy Policy for details. Categories of data: account info, usage logs, prompts and generated outputs (may be processed/anonymized).
- We do not sell users' email addresses or personal data to third parties; we do not sell users' email or any data to anyone.

9. Security
- We implement reasonable measures to protect data but cannot guarantee absolute security.

10. Disclaimers and Liability
- THE SERVICE IS PROVIDED "AS IS". TO THE MAXIMUM EXTENT PERMITTED BY LAW, QUESTGURU'S LIABILITY IS LIMITED.

11. Indemnification
- You agree to indemnify Questguru against third-party claims arising from your content or breach of these Terms.

12. Termination
- We may suspend or terminate accounts for violation. Data handling on termination is governed by published policies.

13. Changes
- We may change these Terms; material changes will be communicated and may require acceptance.

14. Governing Law
- Governing law: Ghaziabad, Uttar Pradesh, India.

Contact
- Support: info@arithmeticinfotech.com
- Privacy contact: info@arithmeticinfotech.com

`;
